<template>
    <access-denied v-if="accessDenied" title="conta-corrente" />
    <div id="main" v-else>
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="page">
            <div class="vertical-flow vh-80">
                <!-- PESQUISA E FILTROS -->
                <div class="filters-bar mb-3">
                    <div class="filters-bar-form form-columns-fit">
                        <div class="columns">
                            <div class="column is-4">
                                <search-bar
                                    :clean="limparBusca"
                                    :onSearch="debouncedOnSearch"
                                    :tooltipLabel="`${$t('msg-campo-busca')} ${$t(
                                            'codigo'
                                        )}, ${$t(
                                            regraTrabalhoLabel[
                                                contaFlex.regraTrabalho
                                            ]
                                        )}, '${$t('criado-por')}'`"
                                />
                            </div>
                            <div class="column is-2">
                                <verified-date-picker
                                    dateType="startDate"
                                    :value="filters.dataInicial"
                                    :endDate="filters.dataFinal"
                                    title="data-inicio"
                                    @input="changeStartDate"
                                    :showClean="false"
                                    required
                                    :invalid="filters.dataInicial == null"
                                    :tooltipLabel="'tooltip-intervalo-data'"
                                    :tooltipPosition="'is-right'"
                                    :tooltipType="'is-dark'"
                                    :tooltipSize="'is-large'"
                                    tooltipMultilined
                                />
                            </div>
                            <div class="column is-2">
                                <verified-date-picker
                                    dateType="endDate"
                                    :value="filters.dataFinal"
                                    :startDate="filters.dataInicial"
                                    title="data-fim"
                                    @input="changeEndDate"
                                    :showClean="false"
                                    required
                                    :invalid="filters.dataFinal == null"
                                />
                            </div>
                            <div class="column is-2">
                                <vss-select
                                    title="tipo"
                                    placeholder="selecione"
                                    :options="tipoList"
                                    :mlLabels="true"
                                    v-model="tipoSelected"
                                    @input="onTipoChange"
                                />
                            </div>
                            <div class="column is-2">
                                <vss-select
                                    title="motivo-lancamento"
                                    v-model="motivoSelected"
                                    :options="motivoList"
                                    :loading="motivoLoading"
                                    @search="carregarMotivo"
                                    @input="carregarDados"
                                    :placeholder="'selecione-uma-opcao'"
                                    clearable
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- LISTAGEM -->
                <div class="registry-wrapper">
                    <MovimentacaoTable
                        ref="movimentacaoTable"
                        :movimentacoes="movimentacoes"
                        :isMobile="isMobile"
                        :sortTable="sortTable"
                        :isEmpty="isEmpty"
                        :isLoading="isLoading"
                        :sharedFilters="sharedFilters"
                    />
                </div>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
    </div>
</template>

<script>
import FlexLancamentoService from "@/services/vendas/financeiro/FlexLancamentoService.js";
import ContainerLoader from "@/components/content/loader/ContainerLoader.vue";
import MovimentacaoTable from "@/components/vendas/financeiro/flex/abas/MovimentacaoTable.vue";
import MotivoService from "@/services/agro/MotivoService.js";
import VerifiedDatePicker from "@/components/shared/form/VerifiedDatePicker.vue";

export default {
    name: "Movimentacao",

    components: {
        ContainerLoader,
        VerifiedDatePicker,
        MovimentacaoTable,
    },
    props: {
        contaFlex: {
            type: Object,
            default: (_) => null,
        },
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("VEN_FLEX"),
            service: new FlexLancamentoService(this.$http, this.$router),
            motivoService: new MotivoService(this.$http, this.$router),
            isLoading: false,
            isEmpty: false,
            permissao: {},
            showModal: false,
            accessDenied: false,
            movimentacoes: [],
            debouncedOnSearch: null,
            permissao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            limparBusca: false,
            tipoList: [
                { label: "todos", id: 2 },
                { label: "credito", id: 1 },
                { label: "debito", id: 0 },
            ],
            tipoSelected: { label: "todos", id: 2 },
            motivoList: [],
            motivoSelected: null,
            motivoLoading: false,
            sharedFilters: {
                queryFilter: "",
                column: "dataHora",
                order: "desc",
                idVenFlex: 0,
                idMotivo: null,
                tipo: 2,
            },
            filters: {
                currentPage: 1,
                perPage: 10,
                dataInicial: this.minusWeeksDay(new Date(), 4, 1),
                dataFinal: new Date(),
            },
            regraTrabalhoLabel: [
                "codigo-pedido",
                "codigo-pedido-retorno",
                "codigo-fatura",
            ],
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "financeiro",
            "flex"
        );

        this.sharedFilters.idVenFlex = this.contaFlex.id;

        if (!this.permissao.read) {
            this.accessDenied = true;
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        recarregarDados() {
            this.carregarDados();
        },
        onTipoChange(val) {
            this.sharedFilters.tipo = val
                ? this.tipoList.find((tipo) => tipo.id === val.id)
                : this.situacoes[0];

            this.carregarDados();
        },
        changeStartDate(date) {
            if (date.getTime() != this.filters.dataInicial.getTime()) {
                this.filters.dataInicial = date;

                const dateCopy = new Date(date);

                const oneYearInFuture = this.plusWeeks(dateCopy, 52);

                if (
                    this.filters.dataFinal.getTime() > oneYearInFuture.getTime()
                ) {
                    this.filters.dataFinal = oneYearInFuture;
                }

                if (!this.isNull(this.filters.dataInicial))
                    this.carregarDados();
            }
        },
        changeEndDate(date) {
            if (date.getTime() != this.filters.dataFinal.getTime()) {
                this.filters.dataFinal = date;

                const dateCopy = new Date(date);

                const oneYearAgo = this.minusWeeksDay(dateCopy, 52);

                if (this.filters.dataInicial.getTime() < oneYearAgo.getTime()) {
                    this.filters.dataInicial = oneYearAgo;
                }

                if (!this.isNull(this.filters.dataFinal)) this.carregarDados();
            }
        },
        minusWeeksDay(date, weeks, day = 0) {
            date.setDate(date.getDate() - 7 * weeks - day);
            return date;
        },
        plusWeeks(date, weeks) {
            date.setDate(date.getDate() + 7 * weeks);
            return date;
        },
        isMobile() {
            return window.innerWidth <= 760;
        },
        sortTable(field, order) {
            this.sharedFilters.column = field;
            this.sharedFilters.order = order;
            this.carregarDados();
        },
        resetPagination() {
            this.pagination.resetPagination = true;
            this.pagination.currentPage = 1;
            this.pagination.perPage =
                this.pagination.perPageOptions[this.pagination.optionStarted];

            this.filters.currentPage = 1;
            this.filters.perPage =
                this.pagination.perPageOptions[this.pagination.optionStarted];

            this.carregarDados(1);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;

            this.filters.perPage = value.perPage;
            this.filters.currentPage = value.currentPage;

            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.sharedFilters.queryFilter = this.removeToSearch(value);
            this.carregarDados(1);
        },
        carregarMotivo() {
            this.motivoLoading = true;
            this.motivoService
                .findAll("motivo", "desc", 0, 10000, 1, [
                    ".*",
                    "CONTA_CORRENTE_FLEX",
                ])
                .then((response) => {
                    this.motivoList = response.content.map(
                        ({
                            id,
                            descricao: label,
                            cor,
                            icone,
                            habilitaobrigaobservacao,
                            inicio,
                        }) => ({
                            id,
                            label,
                            cor,
                            icone: icone.toLowerCase(),
                            habilitaobrigaobservacao,
                            inicio,
                        })
                    );
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally((_) => {
                    this.motivoLoading = false;
                });
        },
        carregarDados() {
            this.isLoading = true;

            this.sharedFilters = {
                ...this.sharedFilters,
                tipo: this.tipoSelected.id,
                idMotivo: this.motivoSelected ? this.motivoSelected.id : null,
            };

            const movimentacaoTotalFilters = {
                ...this.sharedFilters,
                ...this.filters,
            };

            this.service
                .findAllTotais(movimentacaoTotalFilters)
                .then(({ content, totalElements }) => {
                    this.movimentacoes = content.map((movimentacao) => ({
                        customRowKey: this.generateRandomKey(),
                        ...movimentacao,
                    }));

                    this.isEmpty = this.movimentacoes.length < 1;

                    this.pagination.totalRows = totalElements;
                })
                .catch((error) => {
                    this.$root.showMessage("error", "msg-erro-load");
                })
                .finally((_) => {
                    this.$refs.movimentacaoTable.setIsAllToggled(false);
                    this.isLoading = false;
                });
        },
        generateRandomKey() {
            const characters =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let result = "";
            const charactersLength = characters.length;
            for (let i = 0; i < 8; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                );
            }
            return result;
        },
    },
};
</script>

<style lang="scss" scoped>
.vh-80 {
    min-height: 80vh;
}
.size {
    width: 100px;
}
.h-max-content {
    height: max-content;
}
.g-2 {
    gap: 8px;
}
.card-content {
    .content {
        font-weight: bold;
        text-align: center;
        font-size: 3vw;
    }
}
.green {
    color: #7cb342;
}
.orange {
    color: #ffb300;
}
#main {
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;

        // Barra de filtro
        .filters-bar {
            display: flex;
            .filters-bar-form {
                flex-grow: 1;
            }
            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: flex-end;
                    margin-left: 10px;
                    margin-bottom: 12px;
                }
            }
            @media screen and (max-width: 850px) {
                flex-direction: column;
                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
